import { useEffect, useLayoutEffect } from 'react';

/**
 * SSR 안전한 `useLayoutEffect`.
 *
 * `useLayoutEffect` 는 서버 렌더 시 실행되지 않으므로 React 가
 * "useLayoutEffect does nothing on the server" 경고를 출력한다. core-ui 는 Next.js 등
 * SSR 호스트에 배포되는 라이브러리라 이 경고가 호스트 콘솔/서버 로그를 오염시킨다.
 *
 * 서버에서는 `useEffect` (렌더 중 실행 안 됨 → noop), 클라이언트에서는 `useLayoutEffect`
 * (paint 전 동기 실행) 로 dispatch 하여 동작은 그대로 두고 경고만 제거한다.
 *
 * DOM 측정 / paint 전 동기 보정이 필요한 곳에서만 사용한다. 그 외에는 `useEffect` 사용.
 */
export const useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
